(function(){
  const format=new Intl.NumberFormat('fr-TN',{minimumFractionDigits:0,maximumFractionDigits:2});
  function clean(root){
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
    while(node=walker.nextNode()){
      const match=node.textContent.trim().match(/^([−-]?[\d\s\u00a0\u202f.,]+)\s*TND$/);
      if(!match)continue;
      let value=match[1].replace('−','-').replace(/[\s\u00a0\u202f]/g,'');
      if(value.includes(',')&&value.includes('.')){const decimal=value.lastIndexOf(',')>value.lastIndexOf('.')?',':'.';value=value.split(decimal===','?'.':',').join('').replace(decimal,'.');}
      else value=value.replace(',','.');
      const amount=Number(value);if(Number.isFinite(amount))node.textContent=format.format(amount)+' DT';
    }
  }
  const watched=new WeakSet();
  function scan(){document.querySelectorAll('.evcod-embedded,.evcod-sticky').forEach(root=>{
    if(watched.has(root))return;watched.add(root);clean(root);
    new MutationObserver(()=>clean(root)).observe(root,{childList:true,subtree:true,characterData:true});
  });}
  scan();new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();